<template>
  <div id="confirm">
    <CommonHeader title="パスワードリセット" />
    <div class="infoColumn"
      ><span class="infoTitle">登録したメールアドレス</span
      ><span class="errorMessage"> {{ errorEmail }}</span></div
    >
    <el-input
      v-model="email"
      size="medium"
      placeholder="〇〇@grit.today"
      class="inputInfo"
    ></el-input>

    <div class="infoColumn"
      ><span class="infoTitle">登録した生年月日</span
      ><span class="errorMessage"> {{ errorBirthday }}</span></div
    >
    <el-date-picker
      v-model="birthday"
      type="date"
      placeholder="生年月日"
      class="inputInfo"
    >
    </el-date-picker>

    <div class="infoColumn"
      ><span class="infoTitle">登録した電話番号</span
      ><span class="errorMessage"> {{ errorPhoneNumber }}</span></div
    >
    <el-input
      v-model="phoneNumber"
      size="medium"
      placeholder="08012345678"
      class="inputInfo"
    ></el-input>

    <div class="infoColumnPassword"
      ><span class="infoTitle">新しいパスワード</span><br /><span
        class="infoTitle"
        >(英数字大文字小文字を含む8文字以上)</span
      >
      <span class="errorMessage">{{ errorPassword }}</span>
    </div>
    <el-input
      v-model="password"
      size="medium"
      placeholder="Password1234"
      class="inputInfo"
    ></el-input>

    <div class="infoColumnPassword"
      ><span class="infoTitle">新しいパスワード(確認用)</span>
    </div>
    <el-input
      v-model="confirmPassword"
      size="medium"
      placeholder="Password1234"
      class="inputInfo"
    ></el-input>

    <DefaultButton class="button" @click.native="onNext"
      >変更する</DefaultButton
    >
  </div>
</template>

<script>
import axios from 'axios'
import DefaultButton from '@components/atoms/button.vue'
import CommonHeader from '@components/organisms/common_header.vue'

export default {
  name: 'Confirm',
  components: {
    DefaultButton,
    CommonHeader,
  },
  data() {
    return {
      email: '',
      errorEmail: '',
      birthday: '2000/01/01',
      errorBirthday: '',
      phoneNumber: '',
      errorPhoneNumber: '',
      password: '',
      confirmPassword: '',
      errorPassword: '',
      onClicked: false,
    }
  },
  mounted() {
    if (Object.keys(this.$route.query).length === 0) {
      this.$router.push({ name: 'pass_mail_input' })
    }
  },
  methods: {
    onNext: function() {
      let errorFlg = false

      if (this.password.length === 0) {
        this.errorPassword = '必須項目です'
        errorFlg = true
      } else if (
        !this.password.match('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$')
      ) {
        this.errorPassword =
          'パスワードは英数字大文字小文字を含む8文字以上で入力してください'
        errorFlg = true
      } else if (this.password !== this.confirmPassword) {
        this.errorPassword = '確認用パスワードが間違っています'
        errorFlg = true
      }

      if (this.email.length === 0) {
        this.errorEmail = '必須項目です'
        errorFlg = true
      }

      if (this.birthday.length === 0) {
        this.errorBirthday = '必須項目です'
        errorFlg = true
      }

      if (this.phoneNumber.length === 0) {
        this.errorPhoneNumber = '必須項目です'
        errorFlg = true
      }

      if (!this.onClicked && !errorFlg) {
        this.onClicked = true
        axios
          .patch('/passwords/reset', {
            email: this.email,
            password: this.password,
            birthday: String(this.birthday),
            phone_number: this.phoneNumber,
            reset_password_token: this.$route.query.token,
          })
          .then((res) => {
            this.$router.push({ name: 'pass_password_complete' })
          })
          .catch(() => {
            alert('入力した情報が間違っています')
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../design/common-settings';

.headingSecond {
  margin-left: 20px;
  font-size: $header-second-size;
  font-weight: normal;

  &Comment {
    margin-bottom: 0;
    margin-left: 20px;
    font-size: $header-second-size;
    font-weight: normal;
  }
  &Under {
    width: 90%;
  }
}

.wrap {

}

.infoColumn {
  height: 40px;
  line-height: 40px;
  color: $bg-gray-text-color;
  text-align: left;
  background-color: $bg-gray-color;
}
.infoColumnPassword {
  line-height: 25px;
  color: $bg-gray-text-color;
  text-align: left;
  background-color: $bg-gray-color;
}

.infoTitle {
  margin-left: 15px;
}
.inputInfo {
  width: 80%;
  margin: 10px 10px;
  &Select {
    margin: 10px 10px;
  }
}

.infoDescription {
  margin-left: 20px;
}
.errorMessage {
  color: #dd6161;
}

.commentInput {
  width: 90%;
  margin: 20px 20px;
}

.button {
  margin-bottom: 20px;
  &Cheer {
    margin-bottom: 20px;
    background-color: $like-color;
  }
}
</style>
